import { cn } from "@/shared/lib/utils"

export function PendingComponent({ onDark }: { onDark?: boolean }) {
	return (
		<div className="flex h-full items-center justify-center">
			<div className="flex gap-2.5">
				{[0, 1, 2].map((i) => (
					<div
						key={i}
						className={cn(
							"size-3.5 animate-bounce rounded-full shadow-[inset_0_1px_1px_rgba(255,255,255,0.65),inset_0_-1px_2px_rgba(0,0,0,0.12),0_2px_8px_rgba(0,0,0,0.18)] ring-1 ring-white/30 backdrop-blur-md backdrop-saturate-150 [-webkit-backdrop-filter:blur(12px)_saturate(1.5)]",
							onDark ? "bg-white/35" : "bg-[#77809b]/35",
						)}
						style={{ animationDelay: `${i * 0.15}s` }}
					/>
				))}
			</div>
		</div>
	)
}
